import FanHomeSuggestionComponent from "./FanHomeSuggestionComponent";

export default FanHomeSuggestionComponent;
